module.exports = __webpack_public_path__ + "static/assets/3b14ee212187d0677a32f462bcdf80ea.svg";